import { createElement, FC, ChangeEvent } from 'react';
import { useRadioTheme } from './radio.theme';
import { Container, Input, Dot, Circle } from './radio.ccm.css';
import { Body } from 'legos/typography';
export interface RadioProps {
  /**
   * Set the current checked state.
   * If specified, it must be kept up to date and will be used as the single source of truth
   * If not specified, the radio internal state will be used and can be notified via onChange
   */
  checked?: boolean;
  /**
   * Set the initial radio button state. Only used on initial render if `checked` is not set
   * @default false
   */
  defaultChecked?: boolean;
  /**
   * Set the radio button to disabled. Changes the look and color and makes the onClick not fire
   * @default false
   */
  disabled?: boolean;
  /**
   * Callback event to be notified when the button is clicked
   */
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  /**
   * value for current option
   */
  value: string;
  /**
   * The name of this form field
   */
  name: string;
  /**
   * Display the error message
   * @default false
   */
  error?: boolean;
  /**
   * sets required for current option
   */
  required?: boolean;
}

export const Radio: FC<RadioProps> = (props) => {
  const {
    checked,
    children,
    defaultChecked,
    disabled,
    error,
    name,
    onChange,
    required,
    value
  } = props;
  const {
    borderColor,
    color,
    disabledColor,
    errorColor,
    disabledLabelColor,
    selectedFocusedColor,
    unselectedFocusedColor
  } = useRadioTheme();

  return (
    <Container.label $disabled={disabled} $disabledColor={disabledColor}>
      <Input.input
        type="radio"
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        name={name}
        onChange={onChange}
        required={required}
        value={value}
      ></Input.input>
      <Circle.span
        $selectedFocusedColor={selectedFocusedColor}
        $unselectedFocusedColor={unselectedFocusedColor}
      >
        <Dot.span
          $color={color}
          $error={error}
          $disabledColor={disabledColor}
          $borderColor={borderColor}
          $errorColor={errorColor}
        />
      </Circle.span>
      <Body style={disabled ? { color: disabledLabelColor } : {}}>
        {children}
      </Body>
    </Container.label>
  );
};
